(function () {
  'use strict';

  // API Configuration
  const API_CONFIG = {
    BEARER_TOKEN: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkFsZXggS2ltIiwiaWF0IjoxMzQ1MzIzfQ.fLnUbfoEZZSKlM4H4lCECH2CelyIeQ8uOufmccWctaA',
    REGIONS_URL: 'https://stores.batteryvape.com/api/regions',
    STOCK_BY_REGION_URL: 'https://freshdesk.jd.net.nz/live-stock',
    STOCK_BY_LOCATION_URL: 'https://freshdesk.jd.net.nz/live-stock-by-address',
    GOOGLE_MAPS_API_KEY: 'AIzaSyBgztdn6VyHdBF82tZNlPtfEzeuhoNbW28' // Replace with actual key
  };

  class StockChecker {
    constructor() {
      this.modal = null;
      this.currentSku = null;
      this.currentProduct = null;
      this.autocomplete = null;
      this.regions = [];
      this.enterTrapSet = false;
      this.autocompleteService = null;
      this.searchDebounceTimer = null;
      this.servicesRequested = false;

      // Track last search to enable auto-refresh on variant change
      this.lastRegionId = null;
      this.lastLocation = null; // {lat, lng}
      this.lastRegionSku = null;
      this.lastLocationSku = null;

      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      this.modal = document.getElementById('stock-checker-modal');

      if (!this.modal) {
        console.error('Stock Checker: Modal element not found!');
        return;
      }

      // Move modal to just before </body> to avoid z-index stacking-context
      // and overflow:hidden issues from parent containers
      if (this.modal.parentNode !== document.body) {
        document.body.appendChild(this.modal);
      }

      this.setupEventListeners();
      this.setupSwipeGesture();
    }

    // Google Maps (~380 KB) and the store regions are only needed once the
    // modal is used, so they load on the first open instead of on every
    // product page view.
    loadServices() {
      if (this.servicesRequested) return;
      this.servicesRequested = true;
      this.loadRegions();
      this.loadGoogleMapsAPI();
    }

    setupEventListeners() {
      // Global Enter key trap for the entire modal - prevents form submission
      const modalContent = this.modal.querySelector('.stock-modal-content');
      if (modalContent && !this.enterTrapSet) {
        modalContent.addEventListener('keydown', (e) => {
          if ((e.key === 'Enter' || e.keyCode === 13) && e.target.tagName === 'INPUT') {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
          }
        }, true); // Use capture phase to catch it before other handlers
        this.enterTrapSet = true;
      }

      // Close modal
      const closeBtn = this.modal.querySelector('.stock-modal-close');
      const overlay = this.modal.querySelector('.stock-modal-overlay');

      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
      if (overlay) overlay.addEventListener('click', () => this.close());

      // Tab switching
      this.modal.querySelectorAll('.stock-tab').forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          // Use currentTarget (the button itself) instead of target (which may be a
          // child <font> element injected by browser translation on French/other locales)
          const tabName = e.currentTarget.dataset.tab || e.target.closest('[data-tab]')?.dataset.tab;
          if (tabName) this.switchTab(tabName);
        });
      });

      // Region search input
      const regionInput = document.getElementById('region-input');
      const regionDropdown = document.getElementById('region-dropdown');

      if (regionInput) {
        // Prevent form submission on Enter
        regionInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        });

        // Toggle dropdown on click (since it's readonly)
        regionInput.addEventListener('click', () => {
          // Check if dropdown is currently visible
          const isVisible = regionDropdown && regionDropdown.style.display === 'block';

          if (isVisible) {
            // Close the dropdown if it's open
            regionDropdown.style.display = 'none';
          } else {
            // Open the dropdown if it's closed
            if (this.regions.length > 0) {
              this.showRegionDropdown();
            } else {
              this.loadRegions().then(() => this.showRegionDropdown());
            }
          }
        });

        // Filter regions on input (if we decide to make it editable later)
        regionInput.addEventListener('input', (e) => {
          this.filterRegions(e.target.value);
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', (e) => {
          if (!regionInput.contains(e.target) && !regionDropdown.contains(e.target)) {
            regionDropdown.style.display = 'none';
          }
        });
      }

      // Location input
      const locationInput = document.getElementById('location-input');
      if (locationInput) {
        locationInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        });

        locationInput.addEventListener('input', (e) => {
          const value = e.target.value.trim();
          this.debounceSearch(value);
        });
      }

      // LOCATE ME button
      const locateMeBtn = document.getElementById('locate-me-btn');
      if (locateMeBtn) {
        locateMeBtn.addEventListener('click', () => {
          if (!navigator.geolocation) {
            alert('Geolocation is not supported by your browser');
            return;
          }

          const locateMeLabel = locateMeBtn.querySelector('.locate-me-label');
        //  if (locateMeLabel) locateMeLabel.textContent = 'LOCATING...';
          locateMeBtn.disabled = true;

          navigator.geolocation.getCurrentPosition(
            async (position) => {
              const lat = position.coords.latitude;
              const lng = position.coords.longitude;

              // Fetch stores by location
              this.fetchStockByLocation(lat, lng);

              // Reverse geocode to get address
              try {
                const address = await this.reverseGeocode(lat, lng);
                const locationInput = document.getElementById('location-input');
                if (locationInput) {
                  locationInput.value = address;
                }
              } catch (error) {
                console.error('Reverse geocoding error:', error);
                // Fallback to coordinates if geocoding fails
                const locationInput = document.getElementById('location-input');
                if (locationInput) {
                  locationInput.value = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
                }
              }

           //   if (locateMeLabel) locateMeLabel.textContent = 'LOCATE ME';
              locateMeBtn.disabled = false;
            },
            (error) => {
              console.error('Geolocation error:', error);
              alert('Unable to retrieve your location. Please enter your address manually.');
            //  if (locateMeLabel) locateMeLabel.textContent = 'LOCATE ME';
              locateMeBtn.disabled = false;
            }
          );
        });
      }

      // Back button
      const backBtn = document.getElementById('back-to-results');
      if (backBtn) {
        backBtn.addEventListener('click', () => {
          document.getElementById('store-details').style.display = 'none';
          document.querySelector('.stock-tab-content').style.display = 'block';
        });
      }

      // Tab navigation buttons
      this.setupTabNavigation();
    }

    setupSwipeGesture() {
      // Attach swipe detection to the modal content once — works regardless of tabNavInitialized guard
      const swipeTarget = this.modal.querySelector('.stock-modal-content');
      if (!swipeTarget) return;

      let startX = 0;
      let startY = 0;

      swipeTarget.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      swipeTarget.addEventListener('touchend', (e) => {
        const deltaX = startX - e.changedTouches[0].clientX;
        const deltaY = startY - e.changedTouches[0].clientY;

        // Must be a clear horizontal swipe: at least 30px horizontal,
        // and horizontal distance must be larger than vertical distance
        if (Math.abs(deltaX) < 30) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) return;

        const tabs = ['region', 'location'];
        const activeTab = this.modal.querySelector('.stock-tab.active');
        const currentIndex = activeTab ? tabs.indexOf(activeTab.dataset.tab) : 0;

        if (deltaX > 0) {
          // Swiped LEFT → next tab (location)
          const next = Math.min(currentIndex + 1, tabs.length - 1);
          if (next !== currentIndex) this.switchTab(tabs[next]);
        } else {
          // Swiped RIGHT → previous tab (region)
          const prev = Math.max(currentIndex - 1, 0);
          if (prev !== currentIndex) this.switchTab(tabs[prev]);
        }
      }, { passive: true });
    }

    setupTabNavigation() {
      const tabsContainer = this.modal.querySelector('.stock-tabs');
      const prevBtn = this.modal.querySelector('.tab-nav-prev');
      const nextBtn = this.modal.querySelector('.tab-nav-next');

      if (!tabsContainer || !prevBtn || !nextBtn) {
        return;
      }

      // Check if already initialized
      if (this.tabNavInitialized) {
        // Just update button states
        this.updateTabButtonStates();
        return;
      }

      const tabs = ['region', 'location'];

      // Previous button click → switch to previous tab
      prevBtn.addEventListener('click', () => {
        const activeTab = this.modal.querySelector('.stock-tab.active');
        const currentIndex = activeTab ? tabs.indexOf(activeTab.dataset.tab) : 0;
        const prev = Math.max(currentIndex - 1, 0);
        if (prev !== currentIndex) this.switchTab(tabs[prev]);
      });

      // Next button click → switch to next tab
      nextBtn.addEventListener('click', () => {
        const activeTab = this.modal.querySelector('.stock-tab.active');
        const currentIndex = activeTab ? tabs.indexOf(activeTab.dataset.tab) : 0;
        const next = Math.min(currentIndex + 1, tabs.length - 1);
        if (next !== currentIndex) this.switchTab(tabs[next]);
      });

      // Mark as initialized
      this.tabNavInitialized = true;

      // Initial state - use setTimeout to ensure DOM is fully rendered
      setTimeout(() => this.updateTabButtonStates(), 100);
    }

    updateTabButtonStates() {
      const tabsContainer = this.modal.querySelector('.stock-tabs');
      const prevBtn = this.modal.querySelector('.tab-nav-prev');
      const nextBtn = this.modal.querySelector('.tab-nav-next');

      if (!tabsContainer || !prevBtn || !nextBtn) return;

      const tabs = ['region', 'location'];
      const activeTab = this.modal.querySelector('.stock-tab.active');
      const currentIndex = activeTab ? tabs.indexOf(activeTab.dataset.tab) : 0;

      // Disable prev button if on the first tab
      prevBtn.disabled = currentIndex <= 0;

      // Disable next button if on the last tab
      nextBtn.disabled = currentIndex >= tabs.length - 1;
    }

    async reverseGeocode(lat, lng) {
      // Try using Google Maps Geocoder SDK first if available
      if (typeof google !== 'undefined' && google.maps && google.maps.Geocoder) {
        try {
          const geocoder = new google.maps.Geocoder();
          const response = await geocoder.geocode({ location: { lat, lng } });

          if (response.results && response.results.length > 0) {
            return response.results[0].formatted_address;
          }
        } catch (error) {
          console.error('Google Maps Geocoder error:', error);
        }
      }

      // Fallback to direct API call
      if (!API_CONFIG.GOOGLE_MAPS_API_KEY || API_CONFIG.GOOGLE_MAPS_API_KEY.includes('YOUR_')) {
        return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
      }

      try {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_CONFIG.GOOGLE_MAPS_API_KEY}`;
        const response = await fetch(url);
        const data = await response.json();

        if (data.status === 'OK' && data.results && data.results.length > 0) {
          return data.results[0].formatted_address;
        }
        return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
      } catch (error) {
        console.error('Geocoding API error:', error);
        throw error;
      }
    }

    async loadRegions() {
      try {
        const response = await fetch(API_CONFIG.REGIONS_URL, {
          headers: {
            'Authorization': API_CONFIG.BEARER_TOKEN,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        this.regions = data.regions || data || [];

      } catch (error) {
        console.error('Error loading regions:', error);
        this.regions = [];
      }
    }

    showRegionDropdown(filteredRegions = null) {
      const dropdown = document.getElementById('region-dropdown');
      if (!dropdown) return;

      const regionsToShow = filteredRegions || this.regions;

      if (regionsToShow.length === 0) {
        dropdown.innerHTML = '<div class="region-item" style="color: #999;">No regions found</div>';
        dropdown.style.display = 'block';
        return;
      }

      // Create region items (no placeholder in dropdown)
      dropdown.innerHTML = regionsToShow.map(region => {
        const regionId = region.id || region.region_id;
        const regionName = region.name || region.region_name;

        // Add 'selected' class if this is the currently selected region
        const isSelected = this.selectedRegionId && this.selectedRegionId == regionId;
        const selectedClass = isSelected ? ' selected' : '';

        return `<div class="region-item${selectedClass}" data-region-id="${regionId}" data-region-name="${regionName}">${regionName}</div>`;
      }).join('');

      // Add click handlers
      dropdown.querySelectorAll('.region-item').forEach(item => {
        item.addEventListener('click', () => {
          const regionId = item.dataset.regionId;
          const regionName = item.dataset.regionName;

          if (regionId) {
            // Store the selected region ID
            this.selectedRegionId = regionId;

            document.getElementById('region-input').value = regionName;
            dropdown.style.display = 'none';
            this.fetchStockByRegion(regionId);
          }
        });
      });

      dropdown.style.display = 'block';
    }

    filterRegions(searchTerm) {
      const dropdown = document.getElementById('region-dropdown');
      if (!dropdown) return;

      if (!searchTerm || searchTerm.trim() === '') {
        this.showRegionDropdown();
        return;
      }

      const filtered = this.regions.filter(region => {
        const regionName = (region.name || region.region_name || '').toLowerCase();
        return regionName.includes(searchTerm.toLowerCase());
      });

      this.showRegionDropdown(filtered);
    }

    setupStoreSearch(container) {
      const isRegionTab = container.id === 'region-results';
      const searchInputId = isRegionTab ? 'store-search-input' : 'location-store-search-input';
      const searchInput = document.getElementById(searchInputId);

      if (!searchInput) {
        console.error(`[setupStoreSearch] ERROR: Search input ${searchInputId} not found!`);
        return;
      }

      // Check if already has listener
      const hasListener = searchInput.dataset.listenerAttached === 'true';

      if (hasListener) {
        return;
      }

      // Mark as having listener BEFORE attaching to avoid race conditions
      searchInput.dataset.listenerAttached = 'true';

      // Prevent form submission on Enter
      searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      }, true);

      // Search functionality
      searchInput.addEventListener('input', (e) => {
        const searchTerm = e.target.value.toLowerCase().trim();

        let hasVisibleStores = false;
        const groups = container.querySelectorAll('.store-group');

        if (groups.length === 0) {
          console.warn(`[Search] WARNING: No store groups found in ${container.id}!`);
        }

        groups.forEach((group, index) => {
          const regionName = (group.dataset.region || '').toLowerCase();
          const storeName = group.querySelector('.store-details-panel h4')?.textContent.toLowerCase() || '';

          const matches = searchTerm === '' || regionName.includes(searchTerm) || storeName.includes(searchTerm);

          if (matches) {
            group.style.display = '';
            hasVisibleStores = true;
          } else {
            group.style.display = 'none';
            group.classList.remove('expanded');
          }
        });

        // Show/hide no results message
        let noResultsMsg = container.querySelector('.no-results-message-search');

        if (!hasVisibleStores && searchTerm !== '') {
          if (!noResultsMsg) {
            noResultsMsg = document.createElement('div');
            noResultsMsg.className = 'no-results-message no-results-message-search';
            noResultsMsg.textContent = 'No Store Found';
            noResultsMsg.style.textAlign = 'center';
            noResultsMsg.style.padding = '20px';
            noResultsMsg.style.color = '#666';
            noResultsMsg.style.fontSize = '14px';
            container.appendChild(noResultsMsg);
          }
          noResultsMsg.style.display = 'block';
        } else if (noResultsMsg) {
          noResultsMsg.style.display = 'none';
        }
      });
    }

    loadGoogleMapsAPI() {
      // Check if Google Maps is already loaded
      if (typeof google !== 'undefined' && google.maps) {
        this.initAutocomplete();
        return;
      }

      // Check if script is already being loaded
      const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api"]');
      if (existingScript) {
        // Script is already loading/loaded — wait for places library to be ready
        const waitForPlaces = () => {
          if (typeof google !== 'undefined' && google.maps && google.maps.places && google.maps.places.Autocomplete) {
            this.initAutocomplete();
          } else if (typeof google !== 'undefined' && google.maps && google.maps.importLibrary) {
            google.maps.importLibrary('places').then(() => this.initAutocomplete());
          } else {
            setTimeout(waitForPlaces, 50);
          }
        };
        waitForPlaces();
        return;
      }

      // Create and load the script
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${API_CONFIG.GOOGLE_MAPS_API_KEY}&libraries=places&loading=async`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        // With loading=async the places library may not be ready immediately;
        // use importLibrary when available, otherwise poll until ready.
        if (google.maps.importLibrary) {
          google.maps.importLibrary('places').then(() => this.initAutocomplete());
        } else {
          const wait = setInterval(() => {
            if (google.maps.places && google.maps.places.Autocomplete) {
              clearInterval(wait);
              this.initAutocomplete();
            }
          }, 50);
        }
      };
      document.head.appendChild(script);
    }

    initAutocomplete() {
      const input = document.getElementById('location-input');
      if (!input || typeof google === 'undefined') return;

      this.autocomplete = new google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: 'nz' },
        fields: ['geometry', 'formatted_address'],
      });

      this.autocompleteService = new google.maps.places.AutocompleteService();

      this.autocomplete.addListener('place_changed', () => {
        const place = this.autocomplete.getPlace();
        if (place.geometry && place.geometry.location) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          this.fetchStockByLocation(lat, lng);
          // Clear any error message when a valid place is selected
          const resultsContainer = document.getElementById('location-results');
          if (resultsContainer && resultsContainer.querySelector('.no-results-message')) {
            resultsContainer.innerHTML = '';
          }
        } else {
          // Show error message for invalid input
          const resultsContainer = document.getElementById('location-results');
          if (resultsContainer) {
            resultsContainer.innerHTML = `
              <div class="no-results-message">
                No Details available for input: ${input.value}. Please select suggested input!
              </div>
            `;
          }
        }
      });

   const inputParent = input.closest('.location-input-main');
      if (inputParent) {
        inputParent.style.position = 'relative'; // Ensure parent is relative for absolute positioning
        
        // ✅ FIX: Only capture pac-containers when the modal is OPEN
        // This prevents stealing pac-containers from PDP Click & Collect or Cart autocompletes
        // while still maintaining sticky behavior when scrolling inside the modal
        const modal = this.modal;
        
        // Helper function to check if modal is actually visible
        const isModalOpen = () => {
          if (!modal) return false;
          // Check inline style first (most reliable after open() is called)
          if (modal.style.display === 'block') return true;
          // Check computed style as fallback
          const computedStyle = window.getComputedStyle(modal);
          return computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden';
        };
        
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.classList && node.classList.contains('pac-container')) {
                // ✅ CRITICAL: Only capture if modal is OPEN
                if (!isModalOpen()) {
                  return;
                }
                
                // Check if this pac-container is already inside our inputParent (avoid moving it again)
                if (node.parentElement === inputParent) {
                  return;
                }
                
                inputParent.appendChild(node);
              }
            });
          });
        });
        observer.observe(document.body, { childList: true });
      }
    
    }

    debounceSearch(value) {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      if (!value) {
        const resultsContainer = document.getElementById('location-results');
        if (resultsContainer && resultsContainer.querySelector('.no-results-message')) {
          resultsContainer.innerHTML = '';
        }
        return;
      }

      this.searchDebounceTimer = setTimeout(() => {
        this.checkPredictions(value);
      }, 500);
    }

    checkPredictions(value) {
      if (!this.autocompleteService) return;

      this.autocompleteService.getPlacePredictions({
        input: value,
        componentRestrictions: { country: 'nz' }
      }, (predictions, status) => {
        const resultsContainer = document.getElementById('location-results');
        if (!resultsContainer) return;

        if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions || predictions.length === 0) {
          resultsContainer.innerHTML = `
            <div class="no-results-message">
              No Details available for input: ${value}. Please select suggested input!
            </div>
          `;
        } else {
          // Clear error message if predictions are found
          if (resultsContainer.querySelector('.no-results-message')) {
            resultsContainer.innerHTML = '';
          }
        }
      });
    }

    open(productData, variantId) {
      if (!productData) {
        console.error('Stock Checker: No product data provided');
        return;
      }

      this.currentProduct = productData;
      this.loadServices();

      // Set product image
      const imgEl = document.getElementById('stock-product-image');
      if (imgEl && productData.featured_image) {
        imgEl.src = productData.featured_image;
        imgEl.alt = productData.title || '';
      }

      // Set product title
      const titleEl = document.getElementById('stock-product-title');
      if (titleEl) {
        titleEl.textContent = productData.title || '';
      }

      // Setup variant selector
      this.setupVariantSelector(productData, variantId);

      // Show modal
      this.modal.style.display = 'block';
      document.body.style.overflow = 'hidden';

      // ✅ Capture any existing pac-container when modal opens
      this.captureExistingPacContainer();

      // Setup tab navigation after modal is visible
      this.setupTabNavigation();
    }

    // Helper method to capture existing pac-containers for sticky behavior
    captureExistingPacContainer() {
      const inputParent = document.querySelector('#location-input')?.closest('.location-input-main');
      if (!inputParent) return;
      
      // Find all pac-containers in body that are NOT already in inputParent
      const pacContainers = document.querySelectorAll('body > .pac-container');
      pacContainers.forEach(pac => {
        inputParent.appendChild(pac);
      });
    }

    close() {
     this.releasePacContainers();
      this.modal.style.display = 'none';
      document.body.style.overflow = '';
      this.resetModal();
    }


    // Release pac-containers back to document.body so other autocomplete inputs can use them
    releasePacContainers() {
      const inputParent = document.querySelector('#location-input')?.closest('.location-input-main');
      if (!inputParent) return;

      const pacContainers = inputParent.querySelectorAll('.pac-container');
      pacContainers.forEach(pac => {
        document.body.appendChild(pac);
      });
    }

    resetModal() {
      const regionResults = document.getElementById('region-results');
      const locationResults = document.getElementById('location-results');
      const locationInput = document.getElementById('location-input');
      const regionInput = document.getElementById('region-input');
      const regionDropdown = document.getElementById('region-dropdown');
      const storeDetails = document.getElementById('store-details');
      const tabContent = document.querySelector('.stock-tab-content');

      // Clear search inputs
      const storeSearchInput = document.getElementById('store-search-input');
      const locationStoreSearchInput = document.getElementById('location-store-search-input');

      // Hide stores headers
      const regionHeader = document.querySelector('#region-tab .stores-header');
      const locationHeader = document.querySelector('#location-tab .stores-header');

      if (regionResults) regionResults.innerHTML = '';
      if (locationResults) locationResults.innerHTML = '';
      if (locationInput) locationInput.value = '';
      if (regionInput) regionInput.value = '';
      if (regionDropdown) regionDropdown.style.display = 'none';
      if (storeDetails) storeDetails.style.display = 'none';
      if (tabContent) tabContent.style.display = 'block';

      // Clear search inputs
      if (storeSearchInput) storeSearchInput.value = '';
      if (locationStoreSearchInput) locationStoreSearchInput.value = '';

      // Hide headers
      if (regionHeader) regionHeader.style.display = 'none';
      if (locationHeader) locationHeader.style.display = 'none';

      // Clear last search tracking
      this.lastRegionId = null;
      this.lastLocation = null;
      this.lastRegionSku = null;
      this.lastLocationSku = null;
    }

    setupVariantSelector(product, selectedVariantId) {
      const container = document.getElementById('stock-variant-selector');
      if (!container) return;

      if (!product.variants || product.variants.length <= 1) {
        this.currentSku = product.variants && product.variants[0] ? product.variants[0].sku : '';
        container.innerHTML = '';
        return;
      }

      container.innerHTML = '';
      const variantWrapper = document.createElement('div');
      variantWrapper.className = 'variant-selector-wrapper';

      // Track selected options
      const selectedVariant = product.variants.find(v => v.id == selectedVariantId) || product.variants[0];
      const selectedOptions = {
        option1: selectedVariant.option1,
        option2: selectedVariant.option2,
        option3: selectedVariant.option3
      };

      // Helper to update everything when an option changes
      const refreshVariant = () => {
        const matchedVariant = product.variants.find(v =>
          v.option1 === selectedOptions.option1 &&
          (product.options.length < 2 || v.option2 === selectedOptions.option2) &&
          (product.options.length < 3 || v.option3 === selectedOptions.option3)
        );

        if (matchedVariant) {
          this.currentSku = matchedVariant.sku;

          // Update product image
          const imgEl = document.getElementById('stock-product-image');
          const variantImage = matchedVariant.featured_image || product.featured_image;
          if (imgEl && variantImage) {
            imgEl.src = variantImage;
          }

          // Update all labels and swatch selections
          product.options.forEach((optionName, index) => {
            const optionKey = `option${index + 1}`;
            const selectedValue = selectedOptions[optionKey];

            // Update label value
            const labelValEl = document.querySelector(`.variant-selected-value[data-option-index="${index}"]`);
            if (labelValEl) {
              labelValEl.textContent = selectedValue;
            }

            // Update swatch active state
            const swatches = document.querySelectorAll(`.variant-swatch[data-option-index="${index}"]`);
            swatches.forEach(swatch => {
              swatch.classList.toggle('selected', swatch.dataset.value === selectedValue);
            });
          });

          // Auto-refresh stock data if user had previously searched
          const activeTab = this.modal.querySelector('.stock-tab.active')?.dataset.tab;
          if (activeTab === 'region' && this.lastRegionId) {
            this.fetchStockByRegion(this.lastRegionId);
          } else if (activeTab === 'location' && this.lastLocation) {
            this.fetchStockByLocation(this.lastLocation.lat, this.lastLocation.lng);
          }
        }
      };

      // Render each option row
      product.options.forEach((optionName, index) => {
        const optionKey = `option${index + 1}`;
        const optionRow = document.createElement('div');
        optionRow.className = 'variant-option-row';
        optionRow.style.marginBottom = '1.5rem';

        // Label
        const label = document.createElement('div');
        label.className = 'variant-label';
        label.innerHTML = `${optionName} <span class="variant-label-asterisk">:</span> <span class="variant-selected-value" data-option-index="${index}">${selectedOptions[optionKey]}</span>`;
        optionRow.appendChild(label);

        // Swatches container
        const swatchesContainer = document.createElement('div');
        swatchesContainer.className = 'variant-swatches';
        // Add this line — extra class if NOT color variant
        if (!/color/i.test(optionName)) {
          swatchesContainer.classList.add('non-color-variant');
        }
        // Get unique values for this option
        const uniqueValues = [...new Set(product.variants.map(v => v[optionKey]))].filter(Boolean);

        uniqueValues.forEach(value => {
          const swatch = document.createElement('button');
          swatch.type = 'button';
          swatch.className = 'variant-swatch';
          swatch.dataset.optionIndex = index;
          swatch.dataset.value = value;
          swatch.textContent = value;

          if (value === selectedOptions[optionKey]) {
            swatch.classList.add('selected');
          }

          swatch.addEventListener('click', (e) => {
            e.preventDefault();
            selectedOptions[optionKey] = value;
            refreshVariant();
          });

          swatchesContainer.appendChild(swatch);
        });

        optionRow.appendChild(swatchesContainer);
        variantWrapper.appendChild(optionRow);
      });

      container.appendChild(variantWrapper);

      // Initial SKU set
      this.currentSku = selectedVariant.sku;
    }

    switchTab(tabName) {
      this.modal.querySelectorAll('.stock-tab').forEach((tab) => {
        tab.classList.toggle('active', tab.dataset.tab === tabName);
      });

      this.modal.querySelectorAll('.tab-panel').forEach((panel) => {
        panel.classList.toggle('active', panel.id === `${tabName}-tab`);
      });

      // Update arrow button disabled states to reflect new active tab
      this.updateTabButtonStates();

      // Refresh stock if variant has changed since last fetch for this tab
      if (tabName === 'region' && this.lastRegionId && this.currentSku !== this.lastRegionSku) {
        this.fetchStockByRegion(this.lastRegionId);
      } else if (tabName === 'location' && this.lastLocation && this.currentSku !== this.lastLocationSku) {
        this.fetchStockByLocation(this.lastLocation.lat, this.lastLocation.lng);
      }
    }

    async fetchStockByRegion(regionId) {
      if (!this.currentSku) {
        alert('Something went wrong.');
        return;
      }

      // Prevent redundant API calls if region and SKU are the same
      if (this.lastRegionId === regionId && this.lastRegionSku === this.currentSku) {
        return;
      }

      const resultsContainer = document.getElementById('region-results');
      resultsContainer.innerHTML = '<div class="loading">Loading stores...</div>';

      // Clear the search input when selecting a new region
      const searchInput = document.getElementById('store-search-input');
      if (searchInput) {
        searchInput.value = '';
      }

      // Save last search for auto-refresh on variant change
      this.lastRegionId = regionId;
      this.lastRegionSku = this.currentSku;
      // DO NOT clear lastLocation here to allow switching back and forth

      try {
        const url = `${API_CONFIG.STOCK_BY_REGION_URL}?sku=${encodeURIComponent(
          this.currentSku
        )}&region_id=${encodeURIComponent(regionId)}`;

        const response = await fetch(url, {
          headers: {
            'Authorization': API_CONFIG.BEARER_TOKEN,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          // Try to get error details from response body
          let errorDetails = '';
          try {
            const errorText = await response.text();
            console.error('Error Response Body:', errorText);
            errorDetails = errorText ? `\n\nServer response: ${errorText.substring(0, 200)}` : '';
          } catch (e) {
            console.error('Could not read error response:', e);
          }

          throw new Error(`HTTP error! status: ${response.status}${errorDetails}`);
        }

        const data = await response.json();
        // Parse inventory array from response
        const stores = data.inventory || [];
        this.renderStoreList(stores, resultsContainer);
      } catch (error) {
        console.error('=== Stock Fetch Error ===');
        console.error('Error:', error);
        console.error('Error message:', error.message);
        console.error('Error stack:', error.stack);

        resultsContainer.innerHTML = `
            <div class="error-message">
              <strong>Error loading stores</strong><br>
            </div>
          `;
      }
    }

    async fetchStockByLocation(lat, lng) {
      if (!this.currentSku) {
        alert('Something went wrong.');
        return;
      }

      // Prevent redundant API calls if location and SKU are the same
      if (this.lastLocation &&
        this.lastLocation.lat === lat &&
        this.lastLocation.lng === lng &&
        this.lastLocationSku === this.currentSku) {
        return;
      }

      const resultsContainer = document.getElementById('location-results');
      resultsContainer.innerHTML = '<div class="loading">Finding nearby stores...</div>';

      // Clear the search input when selecting a new location
      const searchInput = document.getElementById('location-store-search-input');
      if (searchInput) {
        searchInput.value = '';
      }

      // Save last search for auto-refresh on variant change
      this.lastLocation = { lat, lng };
      this.lastLocationSku = this.currentSku;
      // DO NOT clear lastRegionId here to allow switching back and forth

      try {
        const url = `${API_CONFIG.STOCK_BY_LOCATION_URL}?sku=${encodeURIComponent(
          this.currentSku
        )}&lat=${lat}&lng=${lng}`;

        const response = await fetch(url, {
          headers: {
            'Authorization': API_CONFIG.BEARER_TOKEN,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          // Try to get error details from response body
          let errorDetails = '';
          try {
            const errorText = await response.text();
            console.error('Error Response Body:', errorText);
            errorDetails = errorText ? `\n\nServer response: ${errorText.substring(0, 200)}` : '';
          } catch (e) {
            console.error('Could not read error response:', e);
          }

          throw new Error(`HTTP error! status: ${response.status}${errorDetails}`);
        }

        const data = await response.json();

        // Parse inventory array from response
        const stores = data.inventory || [];
        this.renderStoreList(stores, resultsContainer);
      } catch (error) {
        console.error('=== Location Stock Fetch Error ===');
        console.error('Error:', error);
        console.error('Error message:', error.message);

        resultsContainer.innerHTML = `
            <div class="error-message">
              <strong>Error loading stores</strong><br>
            </div>
          `;
      }
    }

    renderStoreList(stores, container) {
      // Show/hide header based on results
      const isRegionTab = container.id === 'region-results';
      const headerSelector = isRegionTab ? '#region-tab .stores-header' : '#location-tab .stores-header';
      const header = document.querySelector(headerSelector);

      if (!stores || stores.length === 0) {
        container.innerHTML = '<div class="no-results-message">No Store Found</div>';
        if (header) header.style.display = 'none';
        return;
      }

      if (header) header.style.display = 'flex';

      // Group stores by region/area (extract from outlet_name)
      const storeGroups = {};
      stores.forEach(store => {
        // Extract region from store name (e.g., "Shosha Albany" -> "Albany")
        const storeName = store.outlet_name || 'Store';
        const region = storeName.replace(/^Shosha\s+/i, '').trim() || 'Other';

        if (!storeGroups[region]) {
          storeGroups[region] = [];
        }
        storeGroups[region].push(store);
      });

      // Render store groups
      const groupsHTML = Object.entries(storeGroups).map(([region, regionStores]) => {
        const totalStock = regionStores.reduce((sum, store) => sum + (store.inventory || 0), 0);

        // Get first store for details (assuming one store per region for now)
        const store = regionStores[0];

        // Format hours
        let hoursHTML = '';
        if (store.details && store.details.hours && Array.isArray(store.details.hours)) {
          hoursHTML = store.details.hours.map(dayObj => {
            const dayName = Object.keys(dayObj)[0];
            const times = dayObj[dayName];
            const formattedDay = dayName.charAt(0).toUpperCase() + dayName.slice(1);

            if (times.open === 'CLOSED' || times.closed === 'CLOSED') {
              return `
                  <div class="day-name">${formattedDay}</div>
                  <div class="day-hours">Closed</div>
                `;
            }

            return `
                <div class="day-name">${formattedDay}</div>
                <div class="day-hours">${times.open} - ${times.closed}</div>
              `;
          }).join('');
        }

        return `
            <div class="store-group" data-region="${this.escapeHtml(region)}">
              <div class="store-group-header">
                <div class="store-group-name">${this.escapeHtml(region)}</div>
                <div class="store-group-meta">
                  <div class="store-stock-count">Stock: <span>${totalStock}</span></div>
                  <span class="expand-icon"></span>
                </div>
              </div>
              
              <div class="store-details-panel">
               
                
                <div class="store-details-content-wrapper">
                  <div class="store-info-col">
                   <h4>${this.escapeHtml(store.outlet_name || region)}</h4>
                    ${store.details && store.details.address ? `
                      <div class="store-detail-row">
                        <div class="store-detail-label">Address:</div>
                        <div class="store-detail-value">${this.escapeHtml(store.details.address)}</div>
                      </div>
                    ` : ''}
                    
                    ${store.details && store.details.phone ? `
                      <div class="store-detail-row">
                        <div class="store-detail-label">Phone:</div>
                        <div class="store-detail-value">${this.escapeHtml(store.details.phone)}</div>
                      </div>
                    ` : ''}
                  </div>
                  
                  <div class="store-hours-col">
                    ${hoursHTML ? `
                      <div class="store-hours-grid">
                        ${hoursHTML}
                      </div>
                    ` : ''}
                  </div>
                </div>
              </div>
            </div>
          `;
      }).join('');

      container.innerHTML = groupsHTML;

      // Add click listeners for expand/collapse
      container.querySelectorAll('.store-group-header').forEach((header) => {
        header.addEventListener('click', () => {
          const group = header.parentElement;


          // Toggle current group
          group.classList.toggle('expanded');
        });
      });

      // Setup store search functionality
      this.setupStoreSearch(container);
    }


    showStoreDetails(store) {
      const detailsContainer = document.getElementById('store-details-content');

      // Format hours from API response structure
      let hoursHTML = '';
      if (store.details && store.details.hours) {
        hoursHTML = `
          <div class="store-detail-item">
            <span class="store-detail-label">Opening Hours:</span>
            <div class="store-hours">${this.formatHours(store.details.hours)}</div>
          </div>
        `;
      }

      detailsContainer.innerHTML = `
        <h3>${this.escapeHtml(store.outlet_name || 'Store')}</h3>
        
        ${store.details && store.details.address
          ? `
          <div class="store-detail-item">
            <span class="store-detail-label">Address:</span>
            ${this.escapeHtml(store.details.address)}
          </div>
        `
          : ''
        }
        
        ${store.details && store.details.phone
          ? `
          <div class="store-detail-item">
            <span class="store-detail-label">Phone:</span>
            ${this.escapeHtml(store.details.phone)}
          </div>
        `
          : ''
        }
        
        ${hoursHTML}
        
        <div class="store-detail-item">
          <span class="store-detail-label">Stock Available:</span>
          <span class="store-stock ${store.inventory > 0 ? '' : 'out-of-stock'}">
            ${store.inventory > 0 ? `${store.inventory} units` : 'Out of stock'}
          </span>
        </div>
      `;

      document.querySelector('.stock-tab-content').style.display = 'none';
      document.getElementById('store-details').style.display = 'block';
    }

    formatHours(hours) {
      if (!hours || !Array.isArray(hours)) return 'Contact store for hours';

      return hours.map(dayObj => {
        const dayName = Object.keys(dayObj)[0];
        const times = dayObj[dayName];
        const formattedDay = dayName.charAt(0).toUpperCase() + dayName.slice(1);

        if (times.open === 'CLOSED' || times.closed === 'CLOSED') {
          return `<div><strong>${formattedDay}:</strong> Closed</div>`;
        }

        return `<div><strong>${formattedDay}:</strong> ${times.open} - ${times.closed}</div>`;
      }).join('');
    }

    escapeHtml(text) {
      if (!text) return '';
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }

  // Initialize and expose globally
  window.stockChecker = new StockChecker();
})();
